import request from '@/utils/request'

const baseUrl = '/client/bookMatch/tasks'

export function uploadBookMatch (file, onProgress) {
  const form = new FormData()
  form.append('file', file)
  return request.post(baseUrl + '/upload', form, {
    timeout: 600000,
    showLoading: false,
    onUploadProgress: event => {
      if (event.total && onProgress) onProgress(Math.round(event.loaded * 100 / event.total))
    }
  })
}

export function downloadBookMatchTemplate () {
  return request.get(baseUrl + '/template', {
    responseType: 'blob',
    showLoading: false
  })
}

export function getBookMatchTask (taskId, silent) {
  return request.get(baseUrl + '/' + taskId, { showLoading: !silent, silentError: Boolean(silent) })
}

export function getBookMatchPage (params) {
  return request.get(baseUrl + '/page', { params })
}

export function retryBookMatch (taskId) {
  return request.post(baseUrl + '/' + taskId + '/retry')
}

export function cancelBookMatch (taskId) {
  return request.delete(baseUrl + '/' + taskId)
}

export function downloadBookMatch (taskId, issuesOnly) {
  return request.get(baseUrl + '/' + taskId + (issuesOnly ? '/issues' : '/download'), {
    responseType: 'blob',
    timeout: 0,
    showLoading: false
  })
}

export function saveDownload (response, fallbackName) {
  const disposition = response.headers['content-disposition'] || ''
  const encoded = disposition.match(/filename\*=UTF-8''([^;]+)/i)
  let fileName = fallbackName
  if (encoded && encoded[1]) {
    try { fileName = decodeURIComponent(encoded[1]) } catch (e) {}
  }
  const url = window.URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = url
  link.download = fileName
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)
}
